export default {
    ACTIVE: 'active',
    DATEPICKER_IS_OPEN: 'datepicker-is-open',
    DROPDOWN_IS_OPEN: 'dropdown-is-open',
    FADE: 'fade',
    FILTER_IS_OPEN: 'filter-is-open',
    FORM_GROUP: 'js-form-group',
    FORM_GROUP_FLOATING_LABEL: 'form-group--floating-label',
    GALLERY_MODAL_IS_OPEN: 'gallery-modal-is-open',
    HAS_ERROR: 'has-error',
    HAS_FOCUS: 'has-focus',
    HEADER_IS_SCROLLING: 'header-is-scrolling',
    IS_ACTIVE: 'is-active',
    IS_CLICKED: 'is-clicked',
    IS_DISABLED: 'is-disabled',
    IS_HIDDEN: 'is-hidden',
    IS_HIGLIGHTED: 'is-highlighted',
    IS_LOADING: 'is-loading',
    IS_OPEN: 'is-open',
    IS_EXPANDED: 'is-expanded',
    IS_SCROLLABLE: 'is-scrollable',
    JS_INITIALIZED: 'js-initialized',
    KENTICO_CALENDAR_TEXT_BOX: 'CalendarTextBox',
    KENTICO_HAS_DATEPICKER: 'hasDatepicker',
    KENTICO_INPUT: 'EditingFormControlNestedControl',
    KENTICO_INPUT_ERROR: 'Error',
    LANGUAGE_SWITCHER_IS_OPEN: 'langauge-switcher-is-open',
    LOADED: 'loaded',
    MODAL_IS_OPEN: 'modal-is-open',
    NAV_IS_OPEN: 'nav-is-open',
    SAME_HEIGHT: 'js-same-height',
    SAME_HEIGHT_READY: 'js-same-height-ready',
    SCROLL_FORBID: 'u-scroll-forbid',
    SCROLL_FROZEN: 'u-scroll-frozen',
    SEARCH_HAS_VALUE: 'search-has-value',
    SEARCH_IS_OPEN: 'search-is-open',
    SEARCH_DROPDOWN_IS_OPEN: 'search-dropdown-is-open',
    SHOW: 'show',
    SLICK_ACTIVE: 'slick-active',
    SLICK_CLONED: 'slick-cloned',
    SLICK_SLIDE: 'slick-slide',
    SUBNAV_IS_OPEN: 'subnav-is-open'
};
